import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import DropdownMenuEllipsis from "ds/components/DropdownMenu/Ellipsis";
import DropdownMenuItem from "ds/components/DropdownMenu/Item";
import CopyFieldDropdownMenuItem from "components/CopyField/DropdownMenuItem";
import { FlowsProjectRoleBindingView } from "shared/Flows/Projects/useFlowsProject/types";
import { showPreviewPermissionsDrawer } from "components/PreviewPermissions";
import useAnalytics from "hooks/useAnalytics";
import { AnalyticsPageFlows } from "hooks/useAnalytics/pages/flows";

import { showFlowsProjectRoleUnassignConfirmation } from "../UnassignConfirmation";
import { FLOWS_PROJECT_ROLES_REFETCH_QUERIES } from "../constants";

const FlowsProjectDetailsRolesRowActionsCell = ({
  item: roleBinding,
  ...cellProps
}: TableSimpleCellProps<FlowsProjectRoleBindingView>) => {
  const trackSegmentEvent = useAnalytics({
    page: AnalyticsPageFlows.FlowsProjectRoles,
  });

  const handlePreviewPermissions = () => {
    showPreviewPermissionsDrawer({ roleId: roleBinding.role.id });
    trackSegmentEvent("Preview permissions opened");
  };

  const handleUnassign = () => {
    showFlowsProjectRoleUnassignConfirmation({
      id: roleBinding.id,
      name: roleBinding.role.name,
      refetchQueries: FLOWS_PROJECT_ROLES_REFETCH_QUERIES,
      source: "table",
    });
  };

  return (
    <TableSimpleCell {...cellProps} stickyRight>
      <DropdownMenuEllipsis tooltip="Role actions">
        <CopyFieldDropdownMenuItem title="Copy ID" value={roleBinding.id} />
        <DropdownMenuItem onAction={handlePreviewPermissions}>Preview permissions</DropdownMenuItem>
        <DropdownMenuItem danger onAction={handleUnassign}>
          Unassign
        </DropdownMenuItem>
      </DropdownMenuEllipsis>
    </TableSimpleCell>
  );
};

export default FlowsProjectDetailsRolesRowActionsCell;
